module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_android_apps.ccb254fbe0f72c8dd3cc95f6c5fab3af.png";